import { useEffect, useRef, useState } from "react";
import AgentActivityPopUp from "./AgentReportPopUp";

import useAuth from "../../hooks/useAuth";
import UseAxiosPrivate from "../../hooks/useAxiosPrivate";
import axios from "axios";
import { useNavigate, useLocation } from "react-router-dom";

import Pagination from "../../components/Table/pagination";

// PDF DOWNLOAD //
import jsPDF from "jspdf";
import "jspdf-autotable";

// EXCEL DOWNLOAD //
import * as XLSX from "xlsx"; // Import all exports from 'xlsx'
import { saveAs } from 'file-saver';

import { ReactComponent as Pdf } from "../../assets/icons/pdf-file-svgrepo-com.svg";
import { ReactComponent as Excel } from "../../assets/icons/excel-svgrepo-com.svg";
import Swal from "sweetalert2";

const AgentReport = () => {
  const [showPopUp, setshowPopUp] = useState(false);
  const [AgentReportData, setAgentReportData] = useState([]);
  const [searchText, setSearchText] = useState([]);

  /// Fro Date ///
  const [fromDate, setFromDate] = useState("");
  /// To Date ///
  const [toDate, setToDate] = useState("");

  var sortFilter = useRef("");

  const Initial_pagination = {
    next: "",
    previous: "",
    count: "",
    total_pages: "",
    current_page: 1,
    current_page_count: 0 
  };

  const [pagination, setPagination] = useState(Initial_pagination);

  // User Login Data //
  const [userLoginData, setUserLoginData] = useState();

  // Get User id //
  const user = useAuth();
  const user_id = user.auth.user_details.id;

  // API CALL For Getting User Login Details //
  const { auth, setAuth } = useAuth();
  const axiosPrivate = UseAxiosPrivate();
  const navigate = useNavigate();
  const location = useLocation();

  const PaginationControl = (type, number) => {
    if (type == "page") {
      if (number <= pagination.total_pages) {
        fetAgetReportData(toDate,fromDate,number);
      } else {
        fetAgetReportData(toDate,fromDate,1);
      }
    } else if (type == "last") {
      fetAgetReportData(toDate,fromDate,pagination.total_pages);
    } else if (type == "prev") {
      if (pagination.current_page > 1) {
        fetAgetReportData(toDate,fromDate,pagination.current_page - 1);
      }
    } else if (type == "next") {
      if (pagination.current_page < pagination.total_pages) {
        fetAgetReportData(toDate,fromDate,pagination.current_page + 1);
      }
    } else {
      fetAgetReportData(toDate,fromDate,1);
    }
  };

  const fetAgetReportData = async (todate, fromdate, pagenumber) => {
    console.log(fromDate,"++++++++",typeof(fromDate))
    let agent_post_data;
    agent_post_data = {
      fromDate: fromdate,
      toDate: todate,
      user_id: user_id,
      page: pagenumber,
      search_data: searchText,
      sortby:sortFilter.current.value
    };

    let config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${auth?.accessToken}`,
      },
      withCredentials: true,
    };

    await axios
      .get(
        process.env.REACT_APP_API_URL + "/contactcentre/agentReport/",
        { params: agent_post_data },
        config
      )
      .then((res) => {
        setAgentReportData(res.data.results);
        setPagination((prevState) => {
          return {
            ...prevState,
            total_pages: res.data?.total_pages || 0,
            previous: res.data?.previous || null,
            next: res.data?.next || null,
            current_page: res.data?.current_page || 0,
            count: res.data?.count || 0,
            page_size: res.data?.page_size || 0,
            current_page_count: res.data?.results?.length || 0 
          };
        });
      })
      .catch((err) => console.log(err));
  };

  useEffect(() => {
    fetAgetReportData(toDate, fromDate, 1);
  }, []);

  const UserActivity = async (e) => {
    let isMounted = true;
    const controller = new AbortController();

    let post_data = {
      userid: e,
      fromDate: fromDate,
      toDate: toDate
    };
    try {
      const response = await axiosPrivate.get(
        "/contactcentre/user-login-activity/" + e + "/",
        {
          params: post_data,
          signal: controller.signal,
        }
      );
      isMounted && setUserLoginData(response.data);
      setshowPopUp(true);
    } catch (err) {
      console.error(err);
      navigate("/login", { state: { from: location }, replace: true });
    }
  };

  const handleOnClose = () => {
    setshowPopUp(false);
  };


  const SearchAgent = () => {
    fetAgetReportData(toDate, fromDate, 1);
  };

  // -------   Download Data  -------- //

  const downloadSheet = async (type) => {
    try {
      const post_data = {
        fromDate: fromDate,
        toDate: toDate,
        user_id: user_id,
        search_data: searchText,
      };
      const controller = new AbortController();
      const response = await axiosPrivate.get(
        process.env.REACT_APP_API_URL + "/contactcentre/download_agent_report/",
        {
          signal: controller.signal,
          params: post_data,
        }
      );

      console.log("========response data", response.data);

      const response_data = response.data;

      try {
        if (type == "PDF") {
          downloadpdfData(response_data);
        } else {
          downloadxcelData(response_data);
        }
      } catch (error) {
        console.error("Error:", error);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const downloadpdfData = (dataset) => {
    try {
      // Use the updated downloadData
      // Create a new jsPDF instance
      const doc = new jsPDF();
      // Add content to the PDF
      doc.text("Agent Report", 10, 10);

      // Extract table data and format it
      const tableData = dataset.map((agent_obj, index) => {
        return [
          index < 9 ? `0${index + 1}` : index + 1,
          agent_obj.agent_user_name,
          agent_obj.total_calls,
          agent_obj.answered_calls,
          agent_obj.notAnswered_calls,
          agent_obj.call_time_duration,
          agent_obj.max_call_duration,
          agent_obj.avg_handling_duration,
          agent_obj.total_loginTime,
          agent_obj.total_breakTime,
          agent_obj.is_deleted ? "Deleted" : "Active",
        ];
      });
      // Define columns for the table
      const tableColumns = [
        { title: "Sl-No", dataKey: "slNo" },
        { title: "Agent", dataKey: "agent_username" },
        { title: "Total Calls", dataKey: "total_calls" },
        { title: "Answered Calls", dataKey: "answered_calls" },
        { title: "Not Answered Calls", dataKey: "notAnswered_calls" },
        { title: "Call Time", dataKey: "call_time"},
        { title: "Max Call Time", dataKey: "max_callTime" },
        { title: "Avg Handling Time", dataKey: "avg_handlingTime" },
        { title: "Total Login Time", dataKey: "total_loginTime" },
        { title: "Total Break Time", dataKey: "total_breakTime" },
        { title: "Status", dataKey: "Status" },
      ];
      // // AutoTable plugin to generate the table
      doc.autoTable({
        head: [tableColumns.map((column) => column.title)],
        body: tableData,
        startY: 20, // Adjust the Y position as needed
      });

      // Save or open the PDF
      doc.save("AgentReport.pdf");
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const downloadxcelData = (dataset) => {
    // Define the fields to exclude
    const excludedFields = ["id"];

    // Create a new array with the desired fields only
    const filteredData = dataset.map((item) => {
      const filteredItem = { ...item };
      excludedFields.forEach((field) => {
        delete filteredItem[field];
      });
      return filteredItem;
    });

    console.log("<<<<<<<<<<<<", filteredData);
    // Create a new workbook
    const wb = XLSX.utils.book_new();

    // Create a worksheet
    const ws = XLSX.utils.json_to_sheet(filteredData);

    // Add the worksheet to the workbook
    XLSX.utils.book_append_sheet(wb, ws, "Agent Report");

    // Generate blob data for the workbook
    const blobData = XLSX.write(wb, { bookType: "xlsx", type: "array" });

    // Convert the blob data to a Uint8Array
    const uint8Array = new Uint8Array(blobData);

    // Create a blob with the appropriate type
    const excelBlob = new Blob([uint8Array], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    // Create a download link and trigger the download
    const url = window.URL.createObjectURL(excelBlob);
    const a = document.createElement("a");
    a.style.display = "none";
    a.href = url;
    a.download = "agent_report.xlsx"; // Specify the desired file name
    document.body.appendChild(a);
    a.click();

    // Clean up
    window.URL.revokeObjectURL(url);
    document.body.removeChild(a);
  };

  const downloadLogsAsExcel = async (agentId, agentUsername) => {
    const controller = new AbortController();

    let post_data = {
      userid: agentId,
      fromDate: fromDate,
      toDate: toDate,
    };

    try {
      const response = await axiosPrivate.get(
        "/contactcentre/user-login-activity/" + agentId + "/",
        {
          params: post_data,
          signal: controller.signal,
        }
      );

      const logData = response.data;
      let fileName = `Agent ${agentUsername} Logs`;
      const excelData = logData.map(item => ({
        Date: new Date(item.created_at).toLocaleString(),
        Activity: item.activity,
        Reason : item.reason,
      }));

      const ws = XLSX.utils.json_to_sheet(excelData);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, 'Log Data');

      const excelFile = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });

      const blob = new Blob([excelFile], { type: 'application/octet-stream' });
      saveAs(blob, `${fileName}.xlsx`);
  
    } catch (error) {
      console.error("Error fetching log data:", error);
    }
  }

  const [detailedActivityData,setDetailedActivityData] = useState({});

  const activityColour={
    'login':'text-green-700 font-bold',
    'logout':'text-red-500 font-bold',
    'break':'text-orange-500 font-bold',
    'available':'text-blue-500',
    'unavailable':'text-black',
  }
    
  const activityBgColour={
    'login':'bg-green-700',
    'logout':'bg-red-500',
    'break':'bg-orange-500',
    'available':'bg-blue-500',
    'unavailable':'bg-black',
  }


  const DetailedActivityFetch=async(agent_report_obj)=>{

    let post_data = {
      'fromDate':fromDate,
      'toDate':toDate
    }
    await axios
      .get(
        process.env.REACT_APP_API_URL + `/contactcentre/agent_detailed_activity_fetch/${agent_report_obj.id}`,
        {
          params:post_data
        },
      )
      .then((res) => {
        console.log(JSON.stringify(res?.data))

        // alert(JSON.stringify(res.data))

        if(res?.data)
        {

          setDetailedActivityData(res.data)

          // const loginData = detailedActivityData.login_data;

          const loginRows = res.data?.login_data.map((item,index)=>`
            <tr>
              <td class="border px-2 py-1 ${activityColour[item.activity]}">${index+1}</td>
              <td class="border px-2 py-1 ${activityColour[item.activity]}">${item.activity}</td>
              <td class="border px-2 py-1 ${activityColour[item.activity]}">${new Date(item.created_at).toLocaleString()}</td>
              <td class="border px-2 py-1 ${activityColour[item.activity]}">${item.activity==='break'? item.reason? item.reason : '""':''}</td>
            </tr>
          `).join("");

          Swal.fire({
                    // title: "Detailed Agent Activity Summary",
                    html:`

                        <h1 style="color:black;font-size:1.2rem;font-weight:bold">Detailed Agent Activity Summary</h1>
                    
                        <div style="width:90%; margin: 0 auto; color: black;margin-top:2rem;font-size:1.2rem;">
          
                          <div class="flex items-center my-4">
                              <div class="flex-grow border-t border-gray-300"></div>
                                  <span class="mx-3 text-sm font-semibold text-gray-700">
                                      👤 Agent Details
                                  </span>
                              <div class="flex-grow border-t border-gray-300"></div>
                          </div>
                       
                          <table class="border-collapse text-sm font-bold" style="width:100%;">
                              <tbody>
                              <tr>
                                  <td style="padding:6px 0; text-align:left;font-size:1rem;">
                                  Agent Name
                                  </td>
                                  <td style="padding:6px 0;text-align:right;font-size:1rem; color: ${agent_report_obj.is_deleted ? "red" : "inherit"};">
                                  ${agent_report_obj.agent_user_name}
                                  </td>
                              </tr>
                          </table>

                          <table class="border-collapse text-sm font-bold" style="width:100%;">
                              <tbody>
                              <tr>
                                  <td style="padding:6px 0; text-align:left;">
                                  From : ${fromDate}
                                  </td>
                                  <td style="padding:6px 0;text-align:right;">
                                  To : ${toDate}
                                  </td>
                              </tr>
                          </table>


                          
                          

                          
                          <div class="flex items-center my-4">
                              <div class="flex-grow border-t border-gray-300"></div>
                                  <span class="mx-3 text-sm font-semibold text-gray-700">
                                      📋 Summary Section
                                  </span>
                              <div class="flex-grow border-t border-gray-300"></div>
                          </div>
          
                          
                          
                          <table class="border-collapse text-sm font-bold" style="width:100%;">
                              <tbody>
                              <tr>
                                  <td style="padding:6px 0; text-align:left;">
                                  Total Calls
                                  </td>
                                  <td style="padding:6px 0;text-align:right;">
                                  ${agent_report_obj.total_calls}  calls
                                  </td>
                              </tr>
                          </table>

                          <table class="border-collapse text-sm font-bold" style="width:100%;">
                              <tbody>
                              <tr>
                                  <td style="padding:6px 0; text-align:left;">
                                  Answered
                                  </td>
                                  <td style="padding:6px 0;text-align:right;">
                                  ${agent_report_obj.answered_calls}  calls
                                  </td>
                              </tr>
                          </table>
                          
                          <table class="border-collapse text-sm font-bold" style="width:100%;">
                              <tbody>
                              <tr>
                                  <td style="padding:6px 0; text-align:left;">
                                  Not Answered
                                  </td>
                                  <td style="padding:6px 0;text-align:right;">
                                  ${agent_report_obj.notAnswered_calls}  calls
                                  </td>
                              </tr>
                          </table>
                          
                          <table class="border-collapse text-sm font-bold" style="width:100%;">
                              <tbody>
                              <tr>
                                  <td style="padding:6px 0; text-align:left;">
                                  Total Login Time
                                  </td>
                                  <td style="padding:6px 0;text-align:right;">
                                  ${agent_report_obj.total_loginTime}
                                  </td>
                              </tr>
                          </table>
                          
                          <table class="border-collapse text-sm font-bold" style="width:100%;">
                          <tbody>
                            <tr>
                              <td style="padding:6px 0; text-align:left;">
                                Total Break Time
                              </td>
                              <td style="padding:6px 0;text-align:right;">
                                ${agent_report_obj.total_breakTime}
                              </td>
                            </tr>
                          </table>
                                  
                                  
                          <div class="flex items-center my-4">
                              <div class="flex-grow border-t border-gray-300"></div>
                                  <span class="mx-3 text-sm font-semibold text-gray-700">
                                      🟢 User Activity
                                  </span>
                              <div class="flex-grow border-t border-gray-300"></div>
                          </div>

                          </br>
                          
                          <div class="flex justify-between">
                            <div class="text-xs"><span class="inline-block w-3 h-3 ${activityBgColour['login']}"></span> Login</div>
                            <div class="text-xs"><span class="inline-block w-3 h-3 ${activityBgColour['logout']}"></span> Logout</div>
                            <div class="text-xs"><span class="inline-block w-3 h-3 ${activityBgColour['break']}"></span> Break</div>
                            <div class="text-xs"><span class="inline-block w-3 h-3 ${activityBgColour['available']}"></span> Available</div>
                            <div class="text-xs"><span class="inline-block w-3 h-3 ${activityBgColour['unavailable']}"></span> Unavailable</div>
                          </div>

                          </br>
                          
                                                    
                          <div class="w-full overflow-x-auto">
                            <table class="min-w-full border-collapse border text-sm">
                              <thead>
                                <tr>
                                  <th class="border px-2 py-1">No</th>
                                  <th class="border px-2 py-1">Activity</th>
                                  <th class="border px-2 py-1">Login Time</th>
                                  <th class="border px-2 py-1">Break Reason</th>
                                </tr>
                              </thead>
                              <tbody>
                                  ${loginRows}
                              </tbody>
                            </table>
                          </div>

 
                         </br>
                         
                         <hr className="border-gray-500 my-5">
          
                          </div>
                          `,
                    // showCancelButton: true,
                    // cancelButtonColor: "#d33",
                    // confirmButtonText: "EDIT THE CAMPAIGN",
                    showCloseButton:true,
                    width:'50%'
                  }).then((result)=>{
                    if(result.isConfirmed){
                      
                    }
                  });


        }

          

      })
      .catch((err) => {
        console.log(err)
        Swal.fire({
          icon: 'warning',
          title: 'Unable to Load Agent Data',
          html: `
            <p style="margin:0;">
              Agent data missing / the selected user not an agent.<br/><br/>
              <small>This may be a temporary network issue. Please try again.</small>
            </p>
          `,
          confirmButtonText: 'Try Again',
          confirmButtonColor: '#3085d6'
        }).then((result) => {
          if (result.isConfirmed) {
            // Call your function again here
            
          }
        });

      }
      );
  }

  return (
    <div>
      <div className="bg-white h-screen">
        <h1 className="font-bold text-lg pt-8 px-4">Agent Report</h1>
        <div className="flex pt-4">
          <div className="flex space-x-4">
            <div className="">
              <div className="relative">
                <input
                  type="text"
                  id="table-search"
                  className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-80 pl-6 p-2.5  "
                  placeholder="Search for items"
                  onChange={(e) => {
                    setSearchText(e.target.value);
                  }}
                />
              </div>
            </div>

            <p>From</p>
            <div className="relative flex space-x-2">
              <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
                <svg
                  className="w-4 h-4 text-gray-500 "
                  aria-hidden="true"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                >
                  <path d="M20 4a2 2 0 0 0-2-2h-2V1a1 1 0 0 0-2 0v1h-3V1a1 1 0 0 0-2 0v1H6V1a1 1 0 0 0-2 0v1H2a2 2 0 0 0-2 2v2h20V4ZM0 18a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V8H0v10Zm5-8h10a1 1 0 0 1 0 2H5a1 1 0 0 1 0-2Z" />
                </svg>
              </div>
              <input
                name="start"
                type="date"
                className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full pl-6 p-2.5  "
                placeholder="From Date"
                onChange={(e) => {
                  setFromDate(e.target.value);
                }}
              />
            </div>
            <p>To</p>
            {/* <span className="mx-4 text-gray-500">to</span> */}
            <div className="relative flex space-x-2">
              <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
                <svg
                  className="w-4 h-4 text-gray-500 "
                  aria-hidden="true"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                >
                  <path d="M20 4a2 2 0 0 0-2-2h-2V1a1 1 0 0 0-2 0v1h-3V1a1 1 0 0 0-2 0v1H6V1a1 1 0 0 0-2 0v1H2a2 2 0 0 0-2 2v2h20V4ZM0 18a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V8H0v10Zm5-8h10a1 1 0 0 1 0 2H5a1 1 0 0 1 0-2Z" />
                </svg>
              </div>
              <input
                name="end"
                type="date"
                className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full pl-6 p-2.5  "
                placeholder="To Date"
                onChange={(e) => {
                  setToDate(e.target.value);
                }}
              />
            </div>

            <div
              className="flex justify-between space-x-3 bg-red-100 p-2 rounded-2xl cursor-pointer"
              onClick={() => downloadSheet("PDF")}
            >
              <Pdf className="w-5 h-5" />
              <h1 className="text-red-500">PDF</h1>
            </div>
            <div
              className="flex justify-between space-x-3 bg-green-100 p-2 rounded-2xl cursor-pointer"
              onClick={() => downloadSheet("EXCEL")}
            >
              <Excel className="w-5 h-5" />
              <h1 className="text-green-500">Excel</h1>
            </div>

            <div className="space-x-2">
              <button
                className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded"
                onClick={SearchAgent}
              >
                Submit
              </button>
            </div>
          </div>
        </div>

        <AgentActivityPopUp
          onClose={handleOnClose}
          visible={showPopUp}
          loginDetails={userLoginData}
        />

        <div className="flex flex-col">
          <div className={`overflow-x-auto sm:-mx-6 lg:-mx-8 ${ auth?.user_details?.type === "agent" ? "h-[65.2vh]" : "h-[71vh]" }`}>
            <div className="py-2 inline-block min-w-full sm:px-6 lg:px-8">
              <div className="overflow-hidden">
                <table className="min-w-full">
                  <thead className="border-b">
                    <tr>
                      <th
                        scope="col"
                        className="text-sm font-bold text-gray-400 px-6 py-4 text-left"
                      >
                        No.
                      </th>
                      <th
                        scope="col"
                        className="text-sm font-bold text-gray-400 px-6 py-4 text-left"
                      >
                        Agent Names
                      </th>
                      <th
                        scope="col"
                        className="text-sm font-bold text-gray-400 px-6 py-4 text-left"
                      >
                        Total Calls
                      </th>
                      <th
                        scope="col"
                        className="text-sm font-bold text-gray-400 px-6 py-4 text-left"
                      >
                        Answered
                      </th>
                      <th
                        scope="col"
                        className="text-sm font-bold text-gray-400 px-6 py-4 text-left"
                      >
                        Not Answered
                      </th>
                      <th
                        scope="col"
                        className="text-sm font-bold text-gray-400 px-6 py-4 text-left"
                      >
                        Call Time
                      </th>
                      <th
                        scope="col"
                        className="text-sm font-bold text-gray-400 px-6 py-4 text-left"
                      >
                        Max Call Time
                      </th>
                      <th
                        scope="col"
                        className="text-sm font-bold text-gray-400 px-6 py-4 text-left"
                      >
                        Average Handling Time
                      </th>
                      <th
                        scope="col"
                        className="text-sm font-bold text-gray-400 px-6 py-4 text-left"
                      >
                        Total Login Time
                      </th>
                      <th
                        scope="col"
                        className="text-sm font-bold text-gray-400 px-6 py-4 text-left"
                      >
                        Total Break Time
                      </th>
                      <th
                        scope="col"
                        className="text-sm font-bold text-gray-400 px-6 py-4 text-left"
                      >
                        Login Activity
                      </th>
                      <th
                        scope="col"
                        className="text-sm font-bold text-gray-400 px-6 py-4 text-left"
                      >
                        Detailed Activity
                      </th>
                    </tr>
                  </thead>

                  <tbody>
                    {AgentReportData.map((agent_report, index) => (
                      <tr className="border-b" key={agent_report.userName}>
                        <td className="px-6 py-4 whitespace-nowrap text-sm font-bold text-gray-900">
                          0{index + 1}
                        </td>
                        <td className="text-sm text-gray-900 font-bold px-6 py-4 whitespace-nowrap " style={{ color: agent_report.is_deleted ? "red" : "inherit" }}>
                          {agent_report.agent_user_name}
                        </td>
                        <td className="text-sm text-gray-900 font-bold px-6 py-4 whitespace-nowrap">
                          {agent_report.total_calls}
                        </td>
                        <td className="text-sm text-gray-900 font-bold px-6 py-4 whitespace-nowrap">
                          {agent_report.answered_calls}
                        </td>
                        <td className="text-sm text-gray-900 font-bold px-6 py-4 whitespace-nowrap">
                          {agent_report.notAnswered_calls}
                        </td>
                        <td className="text-sm text-gray-900 font-bold px-6 py-4 whitespace-nowrap">
                          {agent_report.call_time_duration}
                        </td>
                        <td className="text-sm text-gray-900 font-bold px-6 py-4 whitespace-nowrap">
                          {agent_report.max_call_duration}
                        </td>
                        <td className="text-sm text-gray-900 font-bold px-6 py-4 whitespace-nowrap">
                          {agent_report.avg_handling_duration}
                        </td>
                        <td className="text-sm text-gray-900 font-bold px-6 py-4 whitespace-nowrap">
                          {agent_report.total_loginTime}
                        </td>
                        <td className="text-sm text-gray-900 font-bold px-6 py-4 whitespace-nowrap">
                          {agent_report.total_breakTime}
                        </td>
                        <td className="text-sm text-gray-900 font-bold px-6 py-4 whitespace-nowrap flex items-center space-x-4">
                          <button onClick={() => UserActivity(agent_report.id)}>
                            <svg
                              width="15"
                              height="16"
                              viewBox="0 0 15 16"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M5.4675 8.85192L1.5 12.774V11.5974C1.5 11.4011 1.42098 11.2129 1.28033 11.0741C1.13968 10.9353 0.948912 10.8574 0.75 10.8574C0.551088 10.8574 0.360322 10.9353 0.21967 11.0741C0.0790176 11.2129 0 11.4011 0 11.5974V14.5575C0.00118499 14.6542 0.0215692 14.7497 0.0599999 14.8387C0.136106 15.0195 0.281738 15.1632 0.465 15.2383C0.555167 15.2762 0.651992 15.2963 0.75 15.2975H3.75C3.94891 15.2975 4.13968 15.2195 4.28033 15.0808C4.42098 14.942 4.5 14.7538 4.5 14.5575C4.5 14.3612 4.42098 14.173 4.28033 14.0342C4.13968 13.8954 3.94891 13.8175 3.75 13.8175H2.5575L6.5325 9.90275C6.67373 9.7634 6.75307 9.57441 6.75307 9.37734C6.75307 9.18027 6.67373 8.99127 6.5325 8.85192C6.39127 8.71257 6.19973 8.63429 6 8.63429C5.80027 8.63429 5.60873 8.71257 5.4675 8.85192V8.85192ZM2.5575 1.97711H3.75C3.94891 1.97711 4.13968 1.89915 4.28033 1.76037C4.42098 1.62159 4.5 1.43336 4.5 1.23709C4.5 1.04083 4.42098 0.852599 4.28033 0.713818C4.13968 0.575037 3.94891 0.49707 3.75 0.49707H0.75C0.651992 0.49824 0.555167 0.518353 0.465 0.556272C0.281738 0.631366 0.136106 0.77506 0.0599999 0.955884C0.0215692 1.04485 0.00118499 1.14039 0 1.23709V4.19718C0 4.39345 0.0790176 4.58167 0.21967 4.72046C0.360322 4.85924 0.551088 4.9372 0.75 4.9372C0.948912 4.9372 1.13968 4.85924 1.28033 4.72046C1.42098 4.58167 1.5 4.39345 1.5 4.19718V3.02055L5.4675 6.94266C5.53722 7.01202 5.62017 7.06708 5.71157 7.10465C5.80296 7.14222 5.90099 7.16156 6 7.16156C6.09901 7.16156 6.19704 7.14222 6.28843 7.10465C6.37983 7.06708 6.46278 7.01202 6.5325 6.94266C6.6028 6.87387 6.65859 6.79202 6.69667 6.70184C6.73474 6.61166 6.75435 6.51494 6.75435 6.41725C6.75435 6.31956 6.73474 6.22283 6.69667 6.13265C6.65859 6.04247 6.6028 5.96063 6.5325 5.89183L2.5575 1.97711ZM14.25 10.8574C14.0511 10.8574 13.8603 10.9353 13.7197 11.0741C13.579 11.2129 13.5 11.4011 13.5 11.5974V12.774L9.5325 8.85192C9.39127 8.71257 9.19973 8.63429 9 8.63429C8.80027 8.63429 8.60873 8.71257 8.4675 8.85192C8.32627 8.99127 8.24693 9.18027 8.24693 9.37734C8.24693 9.57441 8.32627 9.7634 8.4675 9.90275L12.4425 13.8175H11.25C11.0511 13.8175 10.8603 13.8954 10.7197 14.0342C10.579 14.173 10.5 14.3612 10.5 14.5575C10.5 14.7538 10.579 14.942 10.7197 15.0808C10.8603 15.2195 11.0511 15.2975 11.25 15.2975H14.25C14.348 15.2963 14.4448 15.2762 14.535 15.2383C14.7183 15.1632 14.8639 15.0195 14.94 14.8387C14.9784 14.7497 14.9988 14.6542 15 14.5575V11.5974C15 11.4011 14.921 11.2129 14.7803 11.0741C14.6397 10.9353 14.4489 10.8574 14.25 10.8574ZM14.94 0.955884C14.8639 0.77506 14.7183 0.631366 14.535 0.556272C14.4448 0.518353 14.348 0.49824 14.25 0.49707H11.25C11.0511 0.49707 10.8603 0.575037 10.7197 0.713818C10.579 0.852599 10.5 1.04083 10.5 1.23709C10.5 1.43336 10.579 1.62159 10.7197 1.76037C10.8603 1.89915 11.0511 1.97711 11.25 1.97711H12.4425L8.4675 5.89183C8.3972 5.96063 8.34141 6.04247 8.30333 6.13265C8.26526 6.22283 8.24565 6.31956 8.24565 6.41725C8.24565 6.51494 8.26526 6.61166 8.30333 6.70184C8.34141 6.79202 8.3972 6.87387 8.4675 6.94266C8.53722 7.01202 8.62017 7.06708 8.71157 7.10465C8.80296 7.14222 8.90099 7.16156 9 7.16156C9.09901 7.16156 9.19704 7.14222 9.28843 7.10465C9.37983 7.06708 9.46278 7.01202 9.5325 6.94266L13.5 3.02055V4.19718C13.5 4.39345 13.579 4.58167 13.7197 4.72046C13.8603 4.85924 14.0511 4.9372 14.25 4.9372C14.4489 4.9372 14.6397 4.85924 14.7803 4.72046C14.921 4.58167 15 4.39345 15 4.19718V1.23709C14.9988 1.14039 14.9784 1.04485 14.94 0.955884V0.955884Z"
                                fill="#7B8897"
                              />
                            </svg>
                          </button>
                          <button onClick={() => downloadLogsAsExcel(agent_report.id, agent_report.agent_username)}>
                            <Excel className="w-6 h-6" />
                          </button>
                        </td>
                        <td>
                          {/* {props.type === "campaignlist_admin" && campaign?.is_invalid_present && ( */}
                          <span>
                            <div className="relative group inline-block ">
                              <svg xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="#00aeff"
                                className="
                                    w-6 h-6 p-0.5 
                                    hover:fill-blue-400 hover:stroke-white hover:p-0 p-0.5 active:fill-none active:stroke-blue-500 active:p-0 p-0.5
                                    transition-colors duration-100 mt-1.5 mx-10 
                                "
                                onClick={()=>DetailedActivityFetch(agent_report)}
                                > 
                              <circle cx="12" cy="12" r="9" strokeWidth="1.8" />
                              <path 
                                d="M12 8.5h.01 M12 11v4" 
                                strokeWidth="2"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                            </svg>

                              <span className="font-bold absolute left-1/2 -translate-x-1/2 mt-[-3.5rem] whitespace-nowrap 
                                              bg-gray-800 text-white text-xs px-2 py-1 rounded opacity-0 
                                              group-hover:opacity-100 transition pointer-events-none">
                                                {/* {campaign?.is_invalid_present? 
                                                    "Invalid Data in campaign" 
                                                  :
                                                    "Nothing to show"
                                                } */}
                                                Detailed Summary
                              </span>
                            </div>
                          </span>
                          {/* )} */}

                          {/* <button class="flex items-center text-sm font-bold gap-2 text-black px-4 py-2 rounded-lg  transition mx-auto hover:text-blue-600 active:text-blue-300">
                              Detailed
                              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="8 0 24 24" stroke-width="4" stroke="currentColor" class="size-5">
                                  <path stroke-linecap="round" stroke-linejoin="round" d="M17.25 8.25 21 12m0 0-3.75 3.75M21 12H3" />
                              </svg>
                          </button> */}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
        {/* {props.camp_search && ( */}
        <div className="p-8">
          <Pagination
            pagination_data={pagination}
            PaginationControl={PaginationControl}
          />
        </div>
        {/* )} */}
      </div>
    </div>
  );
};

export default AgentReport;
